<template>
  <Context ref="context" overflow-scroll max-height-if-outside-viewport>
    <ul class="context__menu">
      <li class="context__menu-item">
        <button
          type="button"
          class="context__menu-item-link"
          :class="{ active: !view.folder_id }"
          @click="move(null)"
        >
          <i class="context__menu-item-icon iconoir-minus"></i>
          {{ $t('viewMoveToFolder.topLevel') }}
        </button>
      </li>
      <li v-for="folder in folders" :key="folder.id" class="context__menu-item">
        <button
          type="button"
          class="context__menu-item-link"
          :class="{ active: view.folder_id === folder.id }"
          @click="move(folder)"
        >
          <i class="context__menu-item-icon iconoir-folder"></i>
          {{ folder.name }}
        </button>
      </li>
    </ul>
  </Context>
</template>

<script>
import context from '@baserow/modules/core/mixins/context'
import { notifyIf } from '@baserow/modules/core/utils/error'

/**
 * Destination picker for moving a view into a folder, or back to the top level.
 *
 * Dragging a view onto a folder in the rail (`ViewsPanel.vue`'s
 * `moveViewToContainer`) does the same move, through the same
 * `view/moveViewToFolder` action -- `v-sortable` grew an opt-in cross-list
 * drop (`containerId`/`onMoveToContainer` in
 * `core/directives/sortable.js`) so this is no longer the only path.
 *
 * This menu still has to exist, though: it is the only way to change a
 * view's folder from the collapsed rail (no room for a folder to drop onto)
 * and by keyboard (dragging has no keyboard equivalent).
 */
export default {
  name: 'ViewMoveToFolderContext',
  mixins: [context],
  props: {
    view: {
      type: Object,
      required: true,
    },
    folders: {
      type: Array,
      required: true,
    },
  },
  emits: ['moved'],
  methods: {
    async move(folder) {
      const folderId = folder === null ? null : folder.id
      if ((this.view.folder_id ?? null) === folderId) {
        this.hide()
        return
      }

      try {
        await this.$store.dispatch('view/moveViewToFolder', {
          view: this.view,
          folder,
        })
      } catch (error) {
        notifyIf(error, 'view')
      }

      this.hide()
      this.$emit('moved')
    },
  },
}
</script>
